export const USER_PASSWORD = 'u_p';
export const USER_LOGIN = 'u_l';
export const ACCESS_TOKEN_EXPIRATION = 'a_t_e';
export const REFRESH_TOKEN = 'r_t';
export const ACCESS_TOKEN = 'a_t';
export const REMEMBER_ME = 'r_m';
export const DEMO_VIEW = 'd_m';
